import { Component } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { ConversionComptesFictifsComponent } from './conversion-comptes-fictifs/conversion-comptes-fictifs.component';
import { ForcerMotPasseComponent } from './forcer-mot-passe/forcer-mot-passe.component';
import { DeplacerUtilisateursComponent } from './deplacer-utilisateurs/deplacer-utilisateurs.component';
import { ModifierNumeroEmployeComponent } from './modifier-numero-employe/modifier-numero-employe.component';
import { RemplacerCourrielExistantComponent } from './remplacer-courriel-existant/remplacer-courriel-existant.component';
import { ChangerPrenomNomComponent } from './changer-prenom-nom/changer-prenom-nom.component';

interface Action {
  value: string;
  label: string;
}

@Component({
    selector: 'app-administration-avancee-managment',
    templateUrl: './administration-avancee-managment.component.html',
    styleUrls: ['./administration-avancee-managment.component.scss'],
    imports: [
    FormsModule,
    MatIcon,
    TranslateModule,
    ConversionComptesFictifsComponent,
    ForcerMotPasseComponent,
    DeplacerUtilisateursComponent,
    ModifierNumeroEmployeComponent,
    RemplacerCourrielExistantComponent,
    ChangerPrenomNomComponent
]
})
export class AdministrationAvanceeManagmentComponent {
  selectedAction: string = 'conversion';

  actions: Action[] = [
    { value: 'conversion', label: 'ADMINISTRATION_AVANCEE.CONVERSION.TITLE' },
    { value: 'forcer_mdp', label: 'ADMINISTRATION_AVANCEE.FORCER_MOT_PASSE.TITLE' },
    { value: 'deplacer', label: 'ADMINISTRATION_AVANCEE.DEPLACER_UTILISATEURS.TITLE' },
    { value: 'modifier_numero_employe', label: 'ADMINISTRATION_AVANCEE.MODIFIER_NUMERO_EMPLOYE.TITLE' },
    { value: 'remplacer_courriel_existant', label: 'ADMINISTRATION_AVANCEE.REMPLACER_COURRIEL_EXISTANT.TITLE' },
    { value: 'changer_prenom_nom', label: 'ADMINISTRATION_AVANCEE.CHANGER_PRENOM_NOM.TITLE' }
  ];
}
